// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const rrn: CountryValidator<"KR", ParsedPersonId> =
  createValidator("kr.rrn", 110);

export default rrn;
export const compact = rrn.compact;
export const format = rrn.format;
export const validate = rrn.validate;
export const generate = (): string =>
  rrn.generate?.() ??
  (() => {
    throw new Error(
      "Validator kr.rrn cannot generate values",
    );
  })();
export const parse = rrn.parse;
